export const FlagDefault = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon Placer">
        <path
          id="Vector (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.666748 1.33325H14.0923C14.6445 1.33325 15.0924 1.78085 15.0924 2.33325C15.0924 2.50769 15.0467 2.67865 14.9606 2.82939C14.9605 2.82944 14.9606 2.82933 14.9606 2.82939L12.7679 6.66658L14.9606 10.5038C15.2345 10.9832 15.068 11.5941 14.5886 11.8681C14.4374 11.9545 14.2664 11.9999 14.0923 11.9999H2.00008V14.6666H0.666748V1.33325ZM2.00008 10.6666V2.66659H13.5179L11.2322 6.66659L13.518 10.6666H2.00008Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
